export default __webpack_public_path__ + "static/media/d10.4bcbcde8.jpg";